import { ButtonPassThroughOptions } from 'primevue';
import { PassThrough } from '@primevue/core';

export enum ButtonType {
  PRIMARY = 'primary',
  DESTRUCTIVE = 'destructive',
  SECONDARY = 'secondary',
  NEUTRAL = 'neutral',
  TERTIARY = 'tertiary',
  QUATERNARY = 'quaternary',
}

export enum ButtonSize {
  MINI = 'mini',
  BASE = 'base',
  MEDIUM = 'medium',
  LARGE = 'large',
}

export enum ButtonIconPosition {
  LEFT = 'left',
  RIGHT = 'right',
}

export type ButtonProps = {
  type: `${ButtonType}`;
  size: `${ButtonSize}`;
  disabled?: boolean;
  icon_position?: `${ButtonIconPosition}`;
  label?: string;
  icon?: string;
  loading?: boolean;
  pt?: PassThrough<ButtonPassThroughOptions>;
};
